import { render, staticRenderFns } from "./Relatorio.vue?vue&type=template&id=8ea2986c&scoped=true&"
import script from "./Relatorio.vue?vue&type=script&lang=js&"
export * from "./Relatorio.vue?vue&type=script&lang=js&"
import style0 from "./Relatorio.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Relatorio.vue?vue&type=style&index=1&id=8ea2986c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea2986c",
  null
  
)

export default component.exports